import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DroppableContainer from './DroppableContainer';
import { Button, Grid, Box } from '@mui/material';
import CustomTrainingModal from './CustomTrainingModal';
import { createCustomTraining } from '../services/customTrainingsService';
import { useSnackbar } from 'notistack';
import { FormattedMessage } from 'react-intl'; 
import CircularProgress from '../../../components/CircularProgress';
import { useAuth } from '../../../contexts/authContext';

const StackedWorkouts = ({ onItemAdded }) => {
  const [isTrainingModalOpen, setIsTrainingModalOpen] = useState(false);
  const [workouts, setWorkouts] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [droppedItems, setDroppedItems] = useState([]);
  const auth = useAuth();

  const getDroppedItems = (callback) => {
    setDroppedItems(callback());
  };

  const openTrainingModal = () => {
    setIsTrainingModalOpen(true);
  };

  const closeTrainingModal = () => {
    setIsTrainingModalOpen(false);
  };

  const handleSaveTraining = async (training) => {
    setLoading(true);
    workouts.map((workout) => ({
      ...workout,
    }));

    const newTraining = {
      name: training.name,
      description: training.description,
      trainingWorkouts: droppedItems,
    };

    try {
      newTraining.creator_id = auth.user.id;
      await createCustomTraining(newTraining);
      enqueueSnackbar(<FormattedMessage id='newTraining.create.msg.success' defaultMessage='Training successfully created' />, {
        variant: 'success',
      });
      
      closeTrainingModal();
    } catch (error) {    
      enqueueSnackbar(<FormattedMessage id='newTraining.create.msg.error' defaultMessage='Create training failed' />, {
        variant: 'error',
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleItemAdded = (newWorkout) => {
    setWorkouts((prevWorkouts) => {
      // Check if the workout with the same ID already exists
      const existingWorkoutIndex = prevWorkouts.findIndex(
        (workout) => workout.id === newWorkout.id
      );
  
      if (existingWorkoutIndex !== -1) {
        // If it exists, update the existing workout
        const updatedWorkouts = [...prevWorkouts];
        updatedWorkouts[existingWorkoutIndex] = newWorkout;
        return updatedWorkouts;
      } else {
        // If it doesn't exist, add the new workout
        return [...prevWorkouts, newWorkout];
      }
    });
  
    onItemAdded(newWorkout);
  };

  const handleReset = () => {
    window.location.reload();
  };

  return (
    <div style={{ flex: 1, padding: '20px', height: '100%', position: 'relative' }}>
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 2000,
          }}
        >
          <CircularProgress />
        </Box>
      )}

      <h3>Vježbe u treningu</h3>
      <Grid container spacing={2} style={{ marginBottom: '10px' }}>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            onClick={openTrainingModal}
            disabled={loading}
          >
            Spremi Trening
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleReset}
            disabled={loading}
          >
            Resetiraj
          </Button>
        </Grid>
      </Grid>
      <DroppableContainer onItemAdded={handleItemAdded} getDroppedItems={getDroppedItems} />

      {/* Render CustomTrainingModal */}
      <CustomTrainingModal
        isOpen={isTrainingModalOpen}
        onClose={closeTrainingModal}
        onSave={handleSaveTraining}
      />
    </div>
  );
};

StackedWorkouts.propTypes = {
  onItemAdded: PropTypes.func.isRequired,
};

export default StackedWorkouts;